export type NameType = 'closing';

export const name: NameType = 'closing';
